import angular from 'angular';
import pipelineStats from './pipelineStats';
import './style.scss';

export default angular
  .module('components.pipelineStats', [])
  .component('pipelineStats', pipelineStats).name;
